<script>
export default {
  data () {
    return {
      modo: 'list'
    }
  },
  methods: {
    onEdit (value) {
      this.modo = 'edit'
      this.$refs.cpEdit.refresh(value)
    },
    onCloseEdit () {
      this.modo = 'list'
      this.$refs.cpGrid.refresh()
    }
  }
}
</script>

<template>
  <div>
    <v-flex xs12 style="margin-top: 10px;">
      <v-toolbar dark color="primary">
        <v-toolbar-title class="white--text hidden-xs-only"> Empresa </v-toolbar-title>
      </v-toolbar>
    </v-flex>
    <v-flex xs12>
      <v-card style="padding: 20px;">
        <app-empresa-edit ref="cpEdit" v-show="modo === 'edit'" @cancel="onCloseEdit" @save="onCloseEdit" />
        <app-empresa-grid ref="cpGrid" v-show="modo === 'list'" @onEdit="onEdit" />
      </v-card>
    </v-flex>
  </div>
</template>
